const parkingPackFromV2 = (pack) => ({
  id: pack.id,
  name: pack.name,
  description: pack.description,
  price: pack.price,
  displayOrder: pack.display_order,
  status: pack.status,
  facility: {
    name: pack.facility.name,
    description: pack.facility.description,
    images: pack.facility.images.map(({ name, file }) => ({ name, file })),
    address: {
      address1: pack.facility.address.address_1,
      city: pack.facility.address.city,
      state: pack.facility.address.state,
      zipCode: pack.facility.address.zip_code,
    },
    amenities: pack.facility.amenities.map(({ name, icon_name }) => ({ name, iconName: icon_name })),
  },
});

export const getParkingPacks = async () => {

  try {
    const { data, error } = await packsCatalogue();
    if (error) {
      console.log('❌ Error getting parking packs', error);
      return [];
    }

    const filteredPacks = (data?.parking_packs ?? []).map(parkingPackFromV2).filter((pack) => pack.status === 'ACTIVE');
    const groupedPacks = filteredPacks?.reduce((acc, pack) => {
      const facility = pack.facility || {};
      const facilityName = facility.name || "Unknown Facility";

      if (!acc[facilityName]) {
        acc[facilityName] = {
          description: facility.description || "No description available",
          images: facility.images || [],
          address: facility.address?.address1,
          city: facility.address?.city,
          state: facility.address?.state,
          zip: facility.address?.zipCode,
          amenities: facility.amenities || [],
          packs: [],
        };
      }

      acc[facilityName].packs.push(pack);

      // Sort packs within each facility by displayOrder
      acc[facilityName].packs.sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));

      return acc;
    }, {});

    if (!groupedPacks) return [];

    return Object.entries(groupedPacks)
      .map(([name, data]) => ({
        name,
        ...data,
        firstDisplayOrder: data.packs.length ? data.packs[0].displayOrder || 0 : 9999,
      }))
      .sort((a, b) => a.firstDisplayOrder - b.firstDisplayOrder);

  } catch (error) {
    console.log('❌ Error getting parking packs', error);
    return [];
  }
}
